View = require 'view'
templates = require 'views/internal/templates'

module.exports = class FormattingHelpView extends View
  viewTitleKey: 'formatting help'

  render: ->
    @$el.html templates.fill('formatting_help')
    @



// WEBPACK FOOTER //
// ./app/scripts/views/card/formatting-help-view.coffee